import GitTypes from 'common/constants/GitTypes';
import { getRequiredScopes } from 'common/services/general.service';
import { Flex } from 'components/base/layout-components';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import { AUTH_METHODS } from '../consts';
import GitProviderInstructions from './GitProviderInstuctions';
import GitProviderSelect from './GitProviderSelect/GitProviderSelect';

const ProviderSetupV2 = () => {
  const [selectedProvider, setSelectedProvider] = useState(GitTypes.GITHUB);
  const [selectedMethod, setSelectedMethod] = useState(AUTH_METHODS.OAUTH);
  const [requiredScopes, setRequiredScopes] = useState([]);
  const isPat = selectedMethod === AUTH_METHODS.PAT;
  const location = useLocation();

  useEffect(() => {
    const loadScopes = async () => {
      const newRequiredScopes = await getRequiredScopes(selectedProvider);
      setRequiredScopes(newRequiredScopes);
    };

    if (isPat) {
      loadScopes();
    }
  }, [isPat, selectedProvider]);

  return (
    <Flex margin='2rem' justify='center'>
      <GitProviderSelect
        selectedMethod={selectedMethod}
        setSelectedMethod={method =>
          setSelectedMethod(method || selectedMethod)
        }
        selectedProvider={selectedProvider}
        setSelectedProvider={provider =>
          setSelectedProvider(provider || selectedProvider)
        }
        isPat={isPat}
        error={location?.state?.error}
      />
      <GitProviderInstructions
        provider={selectedProvider}
        isPat={isPat}
        scopes={requiredScopes}
      />
    </Flex>
  );
};

export default ProviderSetupV2;
